import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useChannelRecordingSchedulesPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canCreate, canUpdate, canDuplicate, canDelete } = useMemo(
    () => ({
      canCreate: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL_RECORDING_SCHEDULE,
      ]),
      canUpdate: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL_RECORDING_SCHEDULE,
      ]),
      canDuplicate: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.CREATE_CHANNEL_RECORDING_SCHEDULE,
      ]),
      canDelete: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.DELETE_CHANNEL_RECORDING_SCHEDULE,
      ]),
    }),
    [hasPlatformPermission]
  );

  return {
    canCreate,
    canUpdate,
    canDuplicate,
    canDelete,
  };
};
